import {BaseContainerModel} from '../base-container.model';
import {bl_applet_plugin_pricing_hdr_RowClass} from '../../dbschema';

export class AppletPluginPricingsContainerModel extends BaseContainerModel {
    bl_applet_plugin_pricing_hdr: bl_applet_plugin_pricing_hdr_RowClass;
}
